<template>
  <div class="sidebar-expanded">
    <div class="sidebar-expanded__top">
      <div class="sidebar-expanded__top__brand">
        <instance-profile-card
          :mask-shade="false"
          :InstanceInfo="InstanceInfo"
          :PersonalProfile="PersonalProfile">
        </instance-profile-card>
      </div>
    </div>
    <!-- end ~ sidebar-expanded__top -->

    <div class="sidebar-expanded__center">
      <div class="sidebar-expanded__menu">
        <nuttrema-loader v-if="InstanceSubscribedPlanSummarized.fetching"></nuttrema-loader>
        <el-menu
           v-else
          :router="true"
          :default-active="$route.name"
          :unique-opened="true"
          class="el-menu--nuttrema-navigation-menu"
          @open="handleOpen"
          @close="handleClose">
          <template v-for="navigation in navigations">

            <template v-if="checkPageRequiredSubscribedFeature(navigation, SubscribedPlan)">
              <el-submenu
                :index="navigation.url"
                v-if="navigation.pages && navigation.pages.length > 0">
                <template slot="title">
                  <span>{{ $t(navigation.label) }}</span>
                </template>
                <template v-for="(page, childIndex) in navigation.pages">

                  <template v-if="_get(page, 'requiredSubscribedFeature')">

                    <permissions-control-wrapper
                       action="label.invite"
                       control-type="subscribed"
                      :clarification="false"
                      :required-subscribed-plan="_get(page, 'requiredSubscribedFeature')"
                      :permissions="_get(InstanceSubscribedPlanSummarized, 'data')">
                      <template slot="allowed">
                        <el-menu-item :index="page.name" :route="{ name: page.name }" :key="page.url">
                          <i v-if="page.navigationIcon" :class="page.navigationIcon"></i>
                          <span>{{ $t(page.label) }}</span>
                        </el-menu-item>
                      </template>

                      <template slot="not-allowed">
                        <el-menu-item-not-allowed class="el-menu-item--not-allowed" index="page.name">
                          <i v-if="page.navigationIcon" :class="page.navigationIcon"></i>
                          <el-tooltip class="item" effect="dark" placement="top" :open-delay="1000">
                            <span slot="content" v-html="_markdown.render($t('permissions.subscribed_plan.missing_feature', { feature: $t(`permissions.subscribed_plan.${_get(page, 'requiredSubscribedFeature')}`) }))"></span>
                            <span>{{ $t(page.label) }} <i class="far fa-lock-alt"></i></span>
                          </el-tooltip>
                        </el-menu-item-not-allowed>
                      </template>
                    </permissions-control-wrapper>

                  </template>

                  <template v-else>
                    <el-menu-item :index="page.name" :route="{ name: page.name }" :key="page.url">
                      <i v-if="page.navigationIcon" :class="page.navigationIcon"></i>
                      <span>{{ $t(page.label) }}</span>
                    </el-menu-item>
                  </template>

                </template>
              </el-submenu>

              <el-menu-item v-else :index="navigation.name" :route="{ name: navigation.name }">
                <i v-if="navigation.navigationIcon" :class="navigation.navigationIcon"></i>
                <span>{{ $t(navigation.label) }}</span>
              </el-menu-item>
            </template>


          </template>
        </el-menu>
      </div>
    </div>
    <!-- end ~ sidebar-expanded__center -->

    <div class="sidebar-expanded__bottom"></div>
</div>
</template>

<script>
import { get } from 'lodash';
import { checkPageRequiredSubscribedFeature } from 'utils/check-permissions';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import SidebarMenu from 'components/ui/menu/sidebar-menu';
import InstanceProfileCard from 'components/ui/card/instance-profile-card';


export default {
  name: 'sidebar-menu-level-zero-expanded',
  mixins: [SidebarMenu],
  components: {
    InstanceProfileCard,
    NuttremaLoader,
  },
  data() {
    return {
      subscriptions: ['message'],
    };
  },
  computed: {
    InstanceInfo() {
      return this.$store.getters.InstanceInfo;
    },
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    InstanceSubscribedPlanSummarized() {
      return this.$store.getters.InstanceSubscribedPlanSummarized;
    },
    SubscribedPlan() {
      return get(this.InstanceSubscribedPlanSummarized, 'data.subscribed_plan');
    },
  },
  methods: {
    checkPageRequiredSubscribedFeature,
    log(e) {
      console.log('clicked!', e);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/level-zero/sidebar-menu-level-zero-expanded.vue